var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-group"},_vm._l((_vm.sensors),function(sensor){return _c('app-sensors',{key:sensor.name,attrs:{"sensor":sensor}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }